import React , {useEffect  , useState} from 'react';
import { Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import Num2persian from 'num2persian';
import { useCurrencyUnit } from 'hooks';

const useStyle = makeStyles(() => ({
  amountString: {
    fontSize: 13,
    color: '#2b3990',
    padding: '8px 0',
    borderRadius: 8,
    marginTop: 0,
  },
}));

const ones = [
  '',
  'یک',
  'دو',
  'سه',
  'چهار',
  'پنج',
  'شش',
  'هفت',
  'هشت',
  'نه',
  'ده',
  'یازده',
  'دوازده',
  'سیزده',
  'چهارده',
  'پانزده',
  'شانزده',
  'هفده',
  'هجده',
  'نوزده',
];
const tens = ['', '', 'بیست', 'سی', 'چهل', 'پنجاه', 'شصت', 'هفتاد', 'هشتاد', 'نود'];
const hundreds = ['', 'صد', 'دویست', 'سیصد', 'چهارصد', 'پانصد', 'ششصد', 'هفتصد', 'هشتصد', 'نهصد'];
const groups = ['', 'هزار', 'میلیون', 'میلیارد', 'بیلیون'];

function convertThreeDigits(num) {
  const n = Number(num);
  if (!n) return '';
  if (n < 20) return ones[n];
  if (n < 100) return tens[Math.floor(n / 10)] + (n % 10 !== 0 ? ' و ' + ones[n % 10] : '');
  return hundreds[Math.floor(n / 100)] + (n % 100 !== 0 ? ' و ' + convertThreeDigits(n % 100) : '');
}

function numberToWords(num) {
  let n = parseInt(num, 10);
  if (isNaN(n) || n === 0) return '';

  let words = '';
  let i = 0;
  while (n > 0) {
    const threeDigits = n % 1000;
    if (threeDigits !== 0) {
      const phrase = convertThreeDigits(threeDigits) + (groups[i] ? ' ' + groups[i] : '');
      words = words ? phrase + ' و ' + words : phrase;
    }
    n = Math.floor(n / 1000);
    i++;
  }
  return words;
}

function convertNumberToPersianWords(number) {
  if (number === null || number === undefined || number === '') return '';

  const cleanNumber = String(number).replace(/,/g, '');
  const [integerPart, decimalPart] = cleanNumber.split('.');

  let parts = [];

  // بخش صحیح
  const integerVal = parseInt(integerPart, 10);
  if (!isNaN(integerVal) && integerVal > 0) {
    parts.push(numberToWords(integerVal) + ' ریال');
  }

  // بخش اعشار
  if (decimalPart) {
    let decimalVal;

    // اگر اعشار یک رقمی بود ×10 شود
    if (decimalPart.length === 1) {
      decimalVal = parseInt(decimalPart, 10) * 10;
    } else {
      decimalVal = parseInt(decimalPart, 10);
    }

    if (!isNaN(decimalVal) && decimalVal > 0) {
      parts.push(numberToWords(decimalVal) + ' قران');
    }
  }

  return parts.join(' و ');
}

export default function NumberToPersianWords({ number }) {
  const classes = useStyle();
  const [checkConfig, setCheckConfig] = useState(null);
  const currencyText = useCurrencyUnit(true);

  useEffect(() => {
    if (currencyText) {
      setCheckConfig(currencyText.newCurrencyFormat);
    }
  }, [currencyText]);
  const result = convertNumberToPersianWords(number);

  if (!result) return null;

  return (
    <Typography className={classes.amountString}>
      {!checkConfig ? Num2persian(number / 10 ?? '') + ' تومان ' : result}
    </Typography>
  );
}
